import React, { createContext, useContext, useState, useEffect } from 'react';
import { checkAdmin } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const init = async () => {
      if (!token) {
        setAuthLoading(false);
        return;
      }
      try {
        const adminStatus = await checkAdmin();
        setIsAdmin(adminStatus);
      } catch {
        setIsAdmin(false);
      } finally {
        setAuthLoading(false);
      }
    };
    init();
  }, [token]);

  const refreshAuth = async () => {
    const adminStatus = await checkAdmin();
    setIsAdmin(adminStatus);
    return adminStatus;
  };

  return (
    <AuthContext.Provider value={{ isAdmin, authLoading, refreshAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
